import {
  getLocalesFromIsoLocale,
  IsoLocale,
  LocaleContent,
  normalizeContentLocale,
  UsaIsoLocale,
} from "@simplyk/common";
import { useRouter } from "next/router";
// eslint-disable-next-line no-restricted-imports
import { i18n } from "next-i18next";

import { OrganizationPageOutput } from "@/common/types/trpc";

export const useOrganizationPageMetaContent = ({
  organizationPage,
}: {
  organizationPage: OrganizationPageOutput;
}): {
  metaTitle: string;
  metaDescription: string;
} => {
  const router = useRouter();

  const isoLocale = (i18n?.language || router.locale || UsaIsoLocale.EN) as IsoLocale;
  const locale = getLocalesFromIsoLocale(isoLocale);

  return LocaleContent.OrganizationPageHeaderMeta[normalizeContentLocale(locale)]({
    orgName: organizationPage?.organization?.name || "Organization",
  });
};
